/**
 * ULID (https://github.com/ulid/spec): 26 chars of Crockford base32 — 48-bit ms timestamp +
 * 80 bits of randomness, monotonic within one millisecond. Client-generated ids for the events
 * the app emits (the idempotency key of `eventsBatch`). Zero dependencies; kept identical to
 * packages/worker/src/lib/ulid.ts (the server uses it for the events it writes itself).
 */
const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'; // Crockford, no I L O U
const TIME_LEN = 10;
const RANDOM_LEN = 16;

let lastTime = -1;
let lastRandom: number[] = [];

function randomBytes(n: number): number[] {
  const out = new Uint8Array(n);
  crypto.getRandomValues(out);
  return Array.from(out);
}

function encodeTime(ms: number): string {
  let s = '';
  let t = ms;
  for (let i = 0; i < TIME_LEN; i++) {
    s = ENCODING[t % 32] + s;
    t = Math.floor(t / 32);
  }
  return s;
}

export function ulid(now: number = Date.now()): string {
  if (now === lastTime) {
    // Monotonic: increment the previous random part (base-32 digits) by one.
    for (let i = RANDOM_LEN - 1; i >= 0; i--) {
      if (lastRandom[i]! < 31) {
        lastRandom[i]!++;
        break;
      }
      lastRandom[i] = 0;
    }
  } else {
    lastTime = now;
    lastRandom = randomBytes(RANDOM_LEN).map((b) => b % 32);
  }
  return encodeTime(now) + lastRandom.map((d) => ENCODING[d]).join('');
}

export const ULID_RE = /^[0-9A-HJKMNP-TV-Z]{26}$/;
export const isUlid = (s: string): boolean => ULID_RE.test(s);
